import React from "react";
import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaChevronRight,
  FaWhatsapp,
} from "react-icons/fa";
import logo from "../assets/images/Home/logo.png";

const Footer = () => {
  // 🎨 Exact Color Codes
  const colors = {
    sectionBg: "#F9FBFA",
    accent: "#D7A19E",
    dark: "#546E7A",
    text: "#4A5A64",
    border: "#C5B358",
  };

  return (
    <>
      {/* ================= WHATSAPP FLOAT BUTTON ================= */}
      <a
        href="https://wa.me/917781855269"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center rounded-full shadow-lg hover:scale-110 transition-all duration-300"
        style={{ backgroundColor: "#25D366", color: "#fff" }}
      >
        <FaWhatsapp size={26} />
      </a>
      <footer
        className="relative pt-24 pb-12 px-4 sm:px-6 overflow-hidden"
        style={{ backgroundColor: colors.sectionBg }}
      >
        {/* Aesthetic Background Elements */}
        <div
          className="absolute top-0 right-0 w-64 h-64 opacity-5 pointer-events-none -mr-20 -mt-20 rounded-full"
          style={{ backgroundColor: colors.border }}
        ></div>
        <div
          className="absolute bottom-0 left-0 w-96 h-96 opacity-5 pointer-events-none -ml-32 -mb-32 rounded-full"
          style={{ backgroundColor: colors.accent }}
        ></div>

        <div className="max-w-7xl mx-auto relative z-10">
          {/* MAIN GRID */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-start">
            {/* 1. BRAND STORY (4 Columns) */}
            <div className="lg:col-span-4 space-y-8 flex flex-col items-center lg:items-start text-center lg:text-left">
              <div
                className="bg-white p-4 flex justify-center items-center rounded-2xl shadow-sm border-b-4"
                style={{ borderColor: colors.border }}
              >
                <img src={logo} alt="Dr Vibha Singh" className="w-44" />
              </div>

              <p
                className="text-md leading-relaxed font-medium italic opacity-90"
                style={{ color: colors.text }}
              >
                "Whether it’s routine gynecology, fertility support, or
                pregnancy care, we guide you through every stage with
                personalized attention and trust."
              </p>

              {/* Social Buttons */}
              <div className="flex gap-4 justify-center lg:justify-start">
                {[
                  {
                    icon: <FaFacebookF />,
                    url: "https://www.facebook.com/drvibhasinghobsgynae/",
                  },
                  {
                    icon: <FaInstagram />,
                    url: "https://www.instagram.com/drvibhasinghobsgynae/",
                  },
                  {
                    icon: <FaYoutube />,
                    url: "https://www.youtube.com/@drvibhasinghobsgynae",
                  },
                ].map((social, i) => (
                  <a
                    key={i}
                    href={social.url}
                    className="w-12 h-12 rounded-xl flex items-center justify-center transition-all duration-300 hover:-translate-y-2 shadow-lg border border-white"
                    style={{ backgroundColor: colors.accent, color: "#fff" }}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* 2. QUICK LINKS (3 Columns) */}
            <div className="lg:col-span-3 lg:pl-10">
              <h3
                className="text-xs uppercase tracking-[0.3em] font-black mb-10 pb-2 border-b-2 inline-block"
                style={{ color: colors.dark, borderColor: colors.border }}
              >
                Menu
              </h3>

              <ul className="space-y-5">
                {[
                  { name: "Home", path: "/" },
                  { name: "About", path: "/about-us" },
                  { name: "Female Infertility", path: "/female-infertility" },
                  { name: "OBS & GYNAE", path: "/obs-gynae" },
                  { name: "Testimonials", path: "/testimonial" },
                  { name: "Contact Us", path: "/contact-us" },
                ].map((link, index) => (
                  <li key={index} className="group">
                    <Link
                      to={link.path}
                      className="text-sm font-semibold transition-all duration-300 flex items-center gap-2 group-hover:gap-4"
                      style={{ color: colors.text }}
                    >
                      <span
                        className="w-0 h-[1px] transition-all duration-300 group-hover:w-6"
                        style={{ backgroundColor: colors.accent }}
                      ></span>
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* 3. CONTACT INFO (5 Columns) */}
            <div className="lg:col-span-5">
              <div className="bg-white/60 backdrop-blur-md p-6 sm:p-8 md:p-10 rounded-[40px] border border-white shadow-2xl shadow-gray-200/50 w-full box-border">
                <h3
                  className="text-xl font-bold mb-8 flex items-center gap-3 justify-center lg:justify-start"
                  style={{ color: colors.dark }}
                >
                  <FaChevronRight
                    className="text-xs"
                    style={{ color: colors.border }}
                  />
                  Get In Touch
                </h3>

                <div className="space-y-6 sm:space-y-8">
                  {/* Phone */}
                  <div className="flex items-center gap-4 sm:gap-5 group">
                    <div
                      className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl flex items-center justify-center shrink-0 shadow-sm border transition-transform group-hover:scale-110"
                      style={{
                        backgroundColor: "#fff",
                        borderColor: colors.border,
                      }}
                    >
                      <FaPhoneAlt style={{ color: colors.accent }} />
                    </div>
                    <div className="flex flex-col">
                      <span className="text-[10px] uppercase font-bold tracking-widest text-gray-400">
                        Appointment
                      </span>
                      <span
                        className="text-lg font-bold"
                        style={{ color: colors.dark }}
                      >
                        +91 77818 55269
                      </span>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="flex items-center gap-4 sm:gap-5 group">
                    <div
                      className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl flex items-center justify-center shrink-0 shadow-sm border transition-transform group-hover:scale-110"
                      style={{
                        backgroundColor: "#fff",
                        borderColor: colors.border,
                      }}
                    >
                      <FaEnvelope style={{ color: colors.accent }} />
                    </div>
                    <div className="flex flex-col">
                      <span className="text-[10px] uppercase font-bold tracking-widest text-gray-400">
                        Mail Us
                      </span>
                      <span
                        className="text-lg font-bold break-words"
                        style={{ color: colors.dark }}
                      >
                        drvibhasingh.gynae@gmail.com
                      </span>
                    </div>
                  </div>

                  {/* Address */}
                  <div className="flex items-start gap-4 sm:gap-5 group">
                    <div
                      className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl flex items-center justify-center shrink-0 shadow-sm border transition-transform group-hover:scale-110"
                      style={{
                        backgroundColor: "#fff",
                        borderColor: colors.border,
                      }}
                    >
                      <FaMapMarkerAlt style={{ color: colors.accent }} />
                    </div>
                    <div className="flex flex-col">
                      <span className="text-[10px] uppercase font-bold tracking-widest text-gray-400">
                        Clinic Location
                      </span>
                      <span
                        className="text-sm leading-relaxed font-medium break-words"
                        style={{ color: colors.text }}
                      >
                        Shop No. 1 & 2, Deewan Plaza, Greater Noida W Rd, near
                        Ace Divino, Sector 1, Aimnabad, Bisrakh Jalalpur,
                        Greater Noida, Bisrakh Jalalpur, Uttar Pradesh 201318
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FOOTER BOTTOM */}
          <div
            className="mt-20 pt-8 border-t flex flex-col md:flex-row flex-wrap justify-center md:justify-between items-center gap-4"
            style={{ borderColor: `${colors.border}40` }}
          >
            <div className="flex flex-col items-center md:items-start text-center md:text-left">
              <p
                className="text-xs font-bold uppercase tracking-widest"
                style={{ color: colors.dark }}
              >
                © 2026 Dr. Vibha Singh | All Rights Reserved
              </p>
            </div>

            <div
              className="h-[2px] w-20 hidden md:block"
              style={{ backgroundColor: colors.border }}
            ></div>

            <p
              className="text-xs font-medium break-words text-center md:text-left"
              style={{ color: colors.text }}
            >
              Designed & Developed by :{" "}
              <a
                href="https://www.digimarqtechnology.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="font-black hover:underline underline-offset-4 decoration-2"
                style={{ color: "#b76e79" }}
              >
                DIGIMARQ TECHNOLOGIES
              </a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
